
import { Component, Prop, Vue } from "vue-property-decorator";

import { AGTestCommand } from "ag-client-typescript";

import MoveButtons from "@/components/MoveButtons.vue";

@Component({
  components: { MoveButtons },
})
export default class AGTestCommandPanel extends Vue {
  @Prop({ required: true, type: AGTestCommand })
  ag_test_command!: AGTestCommand;

  @Prop({ required: false, type: AGTestCommand })
  active_ag_test_command!: AGTestCommand | null;

  @Prop({ required: true, type: Number })
  index!: number;

  @Prop({ required: true, type: Number })
  command_count!: number;
}
